module.exports = __webpack_public_path__ + "img/publication_mascot.aeebdf42.png";